var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08135 0.763397C7.35749 0.763397 7.58135 0.987255 7.58135 1.2634V8.0802L8.67109 6.98609C8.86596 6.79043 9.18254 6.7898 9.3782 6.98467C9.57385 7.17954 9.57448 7.49612 9.37961 7.69178L7.43561 9.64357C7.34179 9.73778 7.21431 9.79073 7.08135 9.79073C6.9484 9.79073 6.82092 9.73778 6.72709 9.64357L4.78309 7.69178C4.58822 7.49612 4.58885 7.17954 4.78451 6.98467C4.98016 6.7898 5.29674 6.79043 5.49161 6.98609L6.58135 8.0802V1.2634C6.58135 0.987255 6.80521 0.763397 7.08135 0.763397ZM3.36455 4.91866C2.28785 4.91866 1.41455 5.79165 1.41455 6.868V10.1247C1.41455 11.2052 2.29069 12.0813 3.37122 12.0813H10.7979C11.8751 12.0813 12.7479 11.2085 12.7479 10.1313V6.87533C12.7479 5.79405 11.8723 4.91866 10.7919 4.91866H10.1699C9.89374 4.91866 9.66988 4.69481 9.66988 4.41866C9.66988 4.14252 9.89374 3.91866 10.1699 3.91866H10.7919C12.4248 3.91866 13.7479 5.24194 13.7479 6.87533V10.1313C13.7479 11.7608 12.4274 13.0813 10.7979 13.0813H3.37122C1.73841 13.0813 0.414551 11.7575 0.414551 10.1247V6.868C0.414551 5.23901 1.73592 3.91866 3.36455 3.91866H3.99255C4.26869 3.91866 4.49255 4.14252 4.49255 4.41866C4.49255 4.69481 4.26869 4.91866 3.99255 4.91866H3.36455Z",
    fill: "#1976d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.e9e8463e4aba6b506fc9640f88cc8852.svg";
export { ForwardRef as ReactComponent };